<template>
  <div class="fundManageIndex">
    <!-- 标题 -->
    <div class="titleBox flex-row ite-c">
      <b>{{topTitle.title}}</b>
      <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
      <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
    </div>

    <!-- 资金统计信息 -->
    <ul class="totalInfo">
      <li class="infoLi boxs">
        <p class="infoTit">
          <img src='@/assets/images/finance/fundManage/icon_income.png' alt="">
          <span>收入资金 (元)</span>
        </p>
        <p class="infoMoney orangeT">{{fundTotal.incomes | centsToYuan}}</p>
        <p @click="goDetailPage(1)" class="infoDetail">
          <span>查看明细</span>
          <img src='@/assets/images/finance/fundManage/icon_double_ri.png' alt="">
        </p>
      </li>

      <li class="infoLi boxs">
        <p class="infoTit">
          <img src='@/assets/images/finance/fundManage/icon_expend.png' alt="">
          <span>支出资金 (元)</span>
        </p>
        <p class="infoMoney lightGT">{{fundTotal.outgoings | centsToYuan}}</p>
        <p @click="goDetailPage(2)" class="infoDetail">
          <span>查看明细</span>
          <img src='@/assets/images/finance/fundManage/icon_double_ri.png' alt="">
        </p>
      </li>

      <li class="infoLi boxs">
        <p class="infoTit">
          <img src='@/assets/images/finance/fundManage/icon_cash.png' alt="">
          <span>提现中资金 (元)</span>
        </p>
        <p class="infoMoney lightOT">{{fundTotal.withdrawing_fees | centsToYuan}}</p>
      </li>

      <li class="infoLi boxs">
        <p class="infoTit">
          <img src='@/assets/images/finance/fundManage/icon_freeze.png' alt="">
          <span>冻结中资金 (元)</span>
        </p>
        <p class="infoMoney blueT">{{fundTotal.frozen_fees | centsToYuan}}</p>
        <p @click="goDetailPage(4)" class="infoDetail">
          <span>查看明细</span>
          <img src='@/assets/images/finance/fundManage/icon_double_ri.png' alt="">
        </p>
      </li>

      <li class="infoLi boxs">
        <p class="infoTit">
          <img src='@/assets/images/finance/fundManage/icon_balance.png' alt="">
          <span>资金余额 (元)</span>
        </p>
        <p class="infoMoney yellowT">{{fundTotal.balance | centsToYuan}}</p>
        <p @click="goDetailPage(5)" class="infoDetail">
          <span>查看明细</span>
          <img src='@/assets/images/finance/fundManage/icon_double_ri.png' alt="">
        </p>
      </li>
    </ul>

    <!-- 筛选条件 -->
    <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
      <template slot="otherCom">

        <el-form-item>
          <el-input
                  v-model="searchForm.params.account"
                  placeholder="输入会员账号"
                  @keyup.enter.native="handleSearch"
                  maxlength="25" size="medium" clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="searchForm.params.memberType" placeholder="请选择会员类型" @change="handleSearch" size="medium"
                     clearable
                     filterable>
            <el-option v-for="item in memberTypeOptions" :key="item.key" :label="item.label"
                       :value="item.key"></el-option>
          </el-select>
        </el-form-item>

      </template>
    </sr-filter>

    <!-- 表格 -->
    <div class="botTable boxs tableTheadGray">
      <div class="tableTop">
        <span class="top_le">资金明细表</span>
        <span class="top_ri">
<!--            <span>会员总数：</span>-->
<!--            <span style="color:#333333;font-size:15px"> {{totalMember}} </span>-->
            <span>网点会员总数：</span>
            <span style="color:#333333;font-size:15px"> {{totalWebsite}} </span>
        </span>
      </div>

      <el-table :data="tableData"
                style="width: 100%;"
                border
                fit
                highlight-current-row
                tooltip-effect="dark"
      >
        <el-table-column label="会员名称" prop="memberName" min-width="130" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="会员类型" prop="memberType" min-width="120" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="会员账号" prop="memberCode" min-width="170" header-align="center" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="账户总余额(元)" prop="total_fee" min-width="129" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
                <span class="orangeT">
                    {{(scope.row.balance) | centsToYuan}}
                </span>
          </template>
        </el-table-column>
        <el-table-column label="可使用余额(元)" prop="" min-width="129" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
                <span class="orangeT">
                    {{(scope.row.usableFee) | centsToYuan}}
                </span>
          </template>
        </el-table-column>
        <el-table-column label="提现中金额(元)" prop="cash_fee" min-width="129" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
                <span class="orangeT">
                    {{(scope.row.withdrawingFee) | centsToYuan}}
                </span>
          </template>
        </el-table-column>
        <el-table-column label="冻结中金额(元)" prop="freeze_fee" min-width="129" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
                <span class="orangeT">
                    {{(scope.row.frozenFee) | centsToYuan}}
                </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="170" header-align="center" align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button @click="showUnfreezeDialog(scope)"
                       class="greenT"
                       icon="el-icon-unlock"
                       type="text"
                       title="解冻">解冻
            </el-button>
            <el-button @click="showFreezeDialog(scope)"
                       class="greenT"
                       icon="el-icon-lock"
                       type="text"
                       title="冻结">冻结
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBox boxs">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="searchForm.current" :page-sizes="[10, 20, 30]" :page-size="searchForm.size"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>


    <!-- 弹窗-冻结资金-start -->
    <el-dialog width="400px" :title="'冻结资金'" :visible.sync="freezeFundDialogFormVisible" @close="closeDialogFreeze"
               :before-close="beforeCloseFreeze" :close-on-click-modal=false :show-close="true">
      <el-form ref="freezeFundForm" :model="freezeForm" label-width="94px">

        <el-row>
          <el-col :span="24">
            <el-form-item label="会员账号：">
              <span>{{freezeForm.memberCode}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="冻结金额：" prop="fee">
              <el-input
                      v-model="freezeForm.fee"
                      :placeholder="'最多可冻结'+freezeForm.usableFee"
                      maxlength="20" clearable
                      @input="e => freezeForm.fee = validForbid(e)"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <span style="font-weight:700; line-height:40px; margin-left:12px; color:#34333A;">元</span>
          </el-col>

        </el-row>

        <div style="line-height:16px; margin-top:12px; margin-left:10px; color:#34333A; z-index:99;">
          请注意：
          <span class="grayT">资金冻结后，用户不可以使用和提现。</span>
        </div>

      </el-form>

      <span slot="footer" class="dialog-footer flex-row jus-c">
          <button @click="beforeCloseFreeze" class="butStyle cancelBtn">取 消</button>
          <button @click="validateFreezeForm" class="butStyle submitBtn">确 定</button>
      </span>
    </el-dialog>
    <!-- 弹窗-冻结资金-end -->


    <!-- 弹窗-冻结资金-start -->
    <el-dialog width="400px" :title="'解冻资金'" :visible.sync="unfreezeFundDialogFormVisible" @close="closeDialogUnfreeze"
               :before-close="beforeCloseUnfreeze" :close-on-click-modal=false :show-close="true">
      <el-form ref="unfreezeFundForm" :model="unfreezeForm" label-width="94px">

        <el-row>
          <el-col :span="24">
            <el-form-item label="会员账号：">
              <span>{{unfreezeForm.memberCode}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="解冻金额：" prop="fee">
              <el-input
                      v-model="unfreezeForm.fee"
                      :placeholder="'最多可解冻'+unfreezeForm.frozenFee"
                      maxlength="20" clearable
                      @input="e => unfreezeForm.fee = validForbid(e)"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <span style="font-weight:700; line-height:40px; margin-left:12px; color:#34333A;">元</span>
          </el-col>

        </el-row>

        <div style="line-height:16px; margin-top:12px; margin-left:10px; color:#34333A; z-index:99;">
          请注意：
          <span class="grayT">资金解冻后，用户可以使用和提现。</span>
        </div>

      </el-form>

      <span slot="footer" class="dialog-footer flex-row jus-c">
          <button @click="beforeCloseUnfreeze" class="butStyle cancelBtn">取 消</button>
          <button @click="validateUnfreezeForm" class="butStyle submitBtn">确 定</button>
      </span>
    </el-dialog>
    <!-- 弹窗-冻结资金-end -->

  </div>
</template>

<script>
  import SrFilter from '@/components/Common/Filter/Filter';
  import {objectToQueryString} from '@/utils/commonUtils.js';
  import {
    IsNumberNotNagtive, // 验证非负数字
    IsNumberNotNagtiveIncludeZeroTwoDecimalPlaces, // 验证必须>=0，可以为小数，最多保留2位小数
  } from '@/utils/validator';
  import {
    getFundCountAPI, // 获取资金统计
    getMemberCountAPI, // 获取会员统计
    getFundListAPI, // 获取资金列表
    fundFreezeAPI, // 冻结资金
    fundUnfreezeAPI, // 解冻资金
  } from '@/api/Finance/fundManage.js';

  // “解冻资金”弹窗提交数据
  const defaultUnfreezeForm = {
    memberId: '',
    memberCode: '',// 会员账号
    fee: null,// 解冻金额
  }

  // “冻结资金”弹窗提交数据
  const defaultFreezeForm = {
    memberId: '',
    memberCode: '',// 会员账号
    fee: null,// 冻结金额
  }

  // 搜索表格的条件
  const searchConst = {
    params: {
      account: null, //输入会员账号
      memberType: -1, //选择会员类型
    },
    current: 1, //当前页码
    size: 10, //每页条数
  }

  export default {
    name: "fundManageIndex",
    data() {
      return {
        //标题
        topTitle: {
          title: '资金管理',
          subTit: '',
          thirdTit: '',
        },

        // 资金统计
        fundTotal: {
          incomes: 0, // 收入资金
          outgoings: 0, // 支出资金
          withdrawing_fees: 0, // 提现中资金
          frozen_fees: 0, // 冻结中资金
          balance: 0, // 资金余额
        },

        totalMember: 0, // 会员总数
        totalWebsite: 0, // 网点会员总数

        // 表格搜索条件
        searchForm: Object.assign({}, searchConst),
        // 会员类型
        memberTypeOptions: [
          {key: -1, label: '全部'},
          {key: 0, label: '代理商会员'},
          {key: 1, label: '网点会员'},
          {key: 2, label: '微店会员'},
          {key: 3, label: '超级会员'},
          {key: 4, label: '平台商/运营商会员'},
          {key: 5, label: '顾客会员'},
        ],

        // 表格数据
        tableData: [],
        // 表格数据总数
        total: 0,


        // “冻结资金”弹窗数据
        freezeForm: Object.assign({}, defaultFreezeForm),
        // 冻结资金窗口是否显示
        freezeFundDialogFormVisible: false,


        // “解冻资金”弹窗数据
        unfreezeForm: Object.assign({}, defaultUnfreezeForm),
        // 解冻资金窗口是否显示
        unfreezeFundDialogFormVisible: false,

      }
    },
    components: {
      SrFilter
    },
    created() {
      this.getFundCount()
      this.getMemberCount()
      this.getDataList()
    },
    methods: {
      // 获取资金统计
      async getFundCount() {
        try {
          const resp = await getFundCountAPI()
          this.fundTotal = resp.data
          console.log(this.fundTotal)
        } catch (e) {
          console.log(e)
        }
      },
      // 获取会员统计
      async getMemberCount() {
        try {
          const resp = await getMemberCountAPI()
          this.totalWebsite = resp.data
        } catch (e) {
          console.log(e)
        }
      },
      // 获取资金列表
      async getDataList() {
        try {
          const resp = await getFundListAPI(this.searchForm)
          this.tableData = resp.data.records
          this.total = parseInt(resp.data.total)
        } catch (e) {
          console.log(e)
          this.$message.error('获取账单明细表格数据')
        }
      },

      // 列表过滤查询
      handleSearch() {
        this.getDataList()
        this.getMemberCount()
      },
      // 搜索重置（清空）
      handleReset() {
        // 初始化参数
        this.searchForm = {
          params: {
            account: null, //输入会员账号
            memberType: null, //选择会员类型
          },
          current: 1, //当前页码
          size: 10, //每页条数
        }
      },
      // 列表每页条数变了
      handleSizeChange(val) {
        this.searchForm.size = val
        this.getDataList()
      },
      // 列表当前页码变了
      handleCurrentChange(val) {
        this.searchForm.current = val
        this.getDataList()
      },

      // 跳转到"资金管理-资金明细"详情页
      goDetailPage(status) {
        this.$router.push({
          path: '/finance/fundManageDetail',
          query: {
            // status: status
          }
        })
      },


      // 显示“冻结资金”弹窗
      showFreezeDialog(scope) {
        this.freezeFundDialogFormVisible = true;

        const rowDate = JSON.parse(JSON.stringify(scope.row));
        this.freezeForm.memberCode = rowDate.account;
        this.freezeForm.memberId = rowDate.memberId;
        this.freezeForm.usableFee = (parseFloat(rowDate.usableFee)/100).toFixed(2);
      },
      // “冻结资金”弹窗关闭前
      beforeCloseFreeze() {
        this.resetFreezeData()
      },
      // “冻结资金”关闭弹窗
      closeDialogFreeze() {
        this.resetFreezeData()
      },
      // 重置“冻结资金”表单
      resetFreezeData() {
        this.freezeFundDialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['freezeFundForm'].clearValidate()
        })
        this.freezeForm = Object.assign({}, defaultFreezeForm)
      },

      // 验证表单-点击“冻结资金”弹窗的“确定”按钮
      validateFreezeForm() {
        if (!this.freezeForm.fee || this.freezeForm.fee == 0) {
          this.$message.error('冻结金额不能为空且不能为0')
          return;
        }
        if ( !IsNumberNotNagtive(this.freezeForm.fee) ) {
          this.$message.error('请输入有效的冻结金额')
          return;
        }
        if (parseFloat(this.freezeForm.fee) > parseFloat(this.freezeForm.usableFee) ) {
          this.$message.error('最多可冻结'+ this.freezeForm.usableFee)
          return;
        }
        this.submitFreezeForm()
      },
      // 提交“冻结资金”表单
      async submitFreezeForm() {
        const param = {
          memberId: this.freezeForm.memberId, //会员账号
          fee: parseFloat(this.freezeForm.fee) * 100 //冻结金额，单位分
        };
        try {
          const result = await fundFreezeAPI(param)
          this.$message.success('资金冻结成功')
          // 重新获取列表数据
          this.getDataList()
          this.getFundCount()
          // 关闭弹窗
          this.closeDialogFreeze()
        } catch (e) {
          console.log(e)
        }
      },


      // 显示“解冻资金”弹窗
      showUnfreezeDialog(scope) {
        this.unfreezeFundDialogFormVisible = true;

        const rowDate = JSON.parse(JSON.stringify(scope.row));
        this.unfreezeForm.memberCode = rowDate.account;
        this.unfreezeForm.memberId = rowDate.memberId;
        this.unfreezeForm.frozenFee = (parseFloat(rowDate.frozenFee)/100).toFixed(2);
      },
      // “解冻资金”弹窗关闭前
      beforeCloseUnfreeze() {
        this.resetUnfreezeData()
      },
      // “解冻资金”关闭弹窗
      closeDialogUnfreeze() {
        this.resetUnfreezeData()
      },
      // 重置“解冻资金”表单
      resetUnfreezeData() {
        this.unfreezeFundDialogFormVisible = false
        this.$nextTick(() => {
          this.$refs['unfreezeFundForm'].clearValidate()
        })
        this.unfreezeForm = Object.assign({}, defaultUnfreezeForm)
      },

      // 验证表单-点击“解冻资金”弹窗的“确定”按钮
      validateUnfreezeForm() {
        if (!this.unfreezeForm.fee || this.unfreezeForm.fee == 0) {
          this.$message.error('解冻金额不能为空且不能为0')
          return;
        }
        if ( !IsNumberNotNagtive(this.unfreezeForm.fee) ) {
          this.$message.error('请输入有效的解冻金额')
          return;
        }
        if (parseFloat(this.unfreezeForm.fee) > parseFloat(this.unfreezeForm.frozenFee) ) {
          this.$message.error('最多可解冻'+ this.unfreezeForm.frozenFee)
          return;
        }
        this.submitUnfreezeForm()
      },
      // 提交“解冻资金”表单
      async submitUnfreezeForm() {
        const param = {
          memberId: this.unfreezeForm.memberId, //会员账号
          fee: parseFloat(this.unfreezeForm.fee) * 100 //解冻金额，单位分
        };
        try {
          const result = await fundUnfreezeAPI(param)
          this.$message.success('资金解冻成功')
          // 重新获取列表数据
          this.getDataList()

          // 关闭弹窗
          this.closeDialogUnfreeze()
        } catch (e) {
          console.log(e)
        }
      },

    },


  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  /* 文字顔色 */
  .orangeT {
    color: #FA6241;
  }

  .lightGT {
    color: #76C819;
  }

  .lightOT {
    color: #F99A1A;
  }

  .blueT {
    color: #3289FF;
  }

  .yellowT {
    color: #FFCC00;
  }

  .greenT {
    color: #2DBAA5;
  }

  .grayT {
    color: #B7B2AF;
  }


  .fundManageIndex {

  }

  // 标题
  .fundManageIndex .titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }

  .titleBox b {
    color: #2B2727;
    font-size: 15px;
  }

  .titleBox span {
    color: #7F7F7F;
    font-size: 13px;
  }

  .titleBox .titRiImg {
    width: 76px;
    height: 24px;
  }


  // 资金统计信息
  .totalInfo {
    margin: 12px 0;
    height: 96px;

    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between
  }

  .totalInfo li.infoLi {
    // float: left;
    height: 96px;
    background: #fff;
    border-radius: 7px;

    // min-width: 206px;
    min-width: 180px;
    width: calc((100% - 48px) / 5);
    padding: 16px 0px 10px 14px;
    display: flex;
    flex-flow: column nowrap;
  }

  .totalInfo li + li {
    margin-left: 12px;
  }

  .totalInfo li.infoLi img {
    width: 16px;
    height: 16px;
  }

  .totalInfo li.infoLi .infoTit {
    color: #4E4A46;
    font-size: 12px;
    display: flex;
    flex-flow: row nowrap;
  }

  .totalInfo li.infoLi .infoTit span {
    margin-left: 2px;
  }

  .totalInfo li.infoLi .infoMoney {
    height: 26px;
    line-height: 26px;
    margin-top: 6px;
    font-size: 20px;
  }

  .totalInfo li.infoLi .infoDetail {
    height: 16px;
    line-height: 16px;
    margin-top: 6px;
    color: #C5C5C5;
    font-size: 12px;
    display: flex;
    flex-flow: row nowrap;
    cursor: pointer;
  }

  .totalInfo li.infoLi .infoDetail span {
    margin-right: 2px;
  }


  // 筛选框
  .fundManageIndex .searchBox {
    // margin-top: 1px;
  }

  // 表格
  .fundManageIndex .botTable {
    margin-top: 12px;
    width: 100%;
  }

  .botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
  }

  .botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
  }

  .botTable .tableTop .top_ri {
    font-size: 12px;
    color: #AAAAAA;
  }

  .botTable .tableTop .top_ri b {
    font-size: 20px;
    font-weight: normal;
    color: #FFCC00;
  }

  .botTable .tableTop .top_ri .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;
    margin-left: 10px;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }

  .botTable .tableTop .top_ri .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
  }

  /* 分页条 */
  .pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
  }


  // 弹窗按钮-取消按钮
  .cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      // background-color: #f1f1f1;
      border: 1px solid #d1d0d0;
    }
  }

  // 弹窗按钮-橙色按钮
  .submitBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
      background-color: rgb(247, 143, 120);
    }
  }


</style>
